module.exports = __webpack_public_path__ + "static/media/197-melilla.7173ca25.svg";